import { alpha } from '@mui/material/styles';

export default function Button(theme) {
  const primary = theme.palette.primary;
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 600,
          letterSpacing: '0.01em',
          textTransform: 'none',
          transition: 'all 0.2s ease',
          '&:hover': { boxShadow: 'none', transform: 'translateY(-1px)' },
          '&:active': { transform: 'translateY(0)' },
        },
        sizeLarge: { height: 48, fontSize: '0.9375rem' },
        sizeSmall: { height: 32, fontSize: '0.8125rem' },
        containedPrimary: {
          background: `linear-gradient(135deg, ${primary.main}, ${primary.dark})`,
          boxShadow: `0 4px 14px ${alpha(primary.main, 0.35)}`,
          '&:hover': {
            background: `linear-gradient(135deg, ${primary.dark}, ${primary.darker})`,
            boxShadow: `0 6px 20px ${alpha(primary.main, 0.5)}`,
          },
        },
        containedSecondary: {
          background: `linear-gradient(135deg, #F59E0B, #B45309)`,
          boxShadow: `0 4px 14px rgba(245,158,11,0.35)`,
          '&:hover': { boxShadow: `0 6px 20px rgba(245,158,11,0.5)` },
        },
        containedError: {
          background: `linear-gradient(135deg, #EF4444, #B91C1C)`,
          boxShadow: `0 4px 14px rgba(239,68,68,0.35)`,
        },
        containedInherit: {
          color: theme.palette.grey[800],
          background: theme.palette.grey[200],
          boxShadow: `0 2px 8px ${theme.palette.grey[500_24]}`,
          '&:hover': { background: theme.palette.grey[300] },
        },
        outlinedPrimary: {
          borderColor: primary.main,
          '&:hover': { background: alpha(primary.main, 0.06), borderColor: primary.dark },
        },
        outlinedInherit: {
          border: `1.5px solid ${theme.palette.grey[300]}`,
          '&:hover': { background: theme.palette.action.hover },
        },
        textInherit: { '&:hover': { background: theme.palette.action.hover } },
      },
    },
  };
}
